import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {credentialsEmail} from '/redux/selector/auth.selector';
import {
  competencyById,
  highestAchievedRankDescriptionById,
  paidAsRankDescLastMonth,
  rankDescriptionById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {isPopoverOpen} from '/redux/selector/popover.selector';
import {
  variablesChatBetaUserEmails,
  variablesFeatureFlag,
} from '/redux/selector/remoteConfig.selector';
import {withProps} from '/util/selector.util';

import Root from './Root';

export default connect(
  createStructuredSelector({
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    rankName: withProps({coachId: userId})(rankDescriptionById),
    competency: withProps({coachId: userId})(competencyById),
    isPopoverOpen,
    featureFlag: variablesFeatureFlag,
    chatBetaUserEmails: variablesChatBetaUserEmails,
    email: credentialsEmail,
    highestRank: withProps({coachId: userId})(
      highestAchievedRankDescriptionById,
    ),
  }),
)(Root);
